// Chat-user-facing document source endpoint client.
//
// Fetches `source_uri` + `original_file_name` for one document so the
// CitationDetailPanel can render an "Open source ↗" link. Backed by
// `app/routes/documents.py` (rag-api, ADR-091-bake-safe — rag-query
// stays frozen because this endpoint lives on the api role only).

import { apiFetch } from "./client";

export interface DocumentSource {
  doc_id: string;
  source_uri: string; // may be "" when missing / source not exposed
  original_file_name: string; // may be ""
}

export async function fetchDocumentSource(
  tenantId: string,
  docId: string,
  token: string,
  opts?: { signal?: AbortSignal },
): Promise<DocumentSource> {
  return apiFetch<DocumentSource>(
    `/v1/tenants/${encodeURIComponent(tenantId)}/documents/${encodeURIComponent(docId)}/source`,
    token,
    { signal: opts?.signal },
  );
}
